<template>
  <div>
    <el-row v-for="(inputComponent, key) in inputComponents()" :key="key" :class="rowCass">
      <el-col :sm="(inputComponent.labelSpan)?inputComponent:8">{{inputComponent.label}}</el-col>
      <el-col :sm="24-((inputComponent.labelSpan)?inputComponent:8)">
        <component
          v-model="content[key]"
          :is="inputComponent.is"
          v-bind="(inputComponent.options)"
          :key="key"
        ></component>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "~/store";

export default {
  name: "s-mini-form",

  props: {
    inputs: { type: Object, default: () => null },
    value: {
      default: null
    },
    stringify: {
      type: Boolean,
      default: false
    },
    rowCass: { default: " mini-row", type: String }
  },

  data() {
    return {
      content: null
    };
  },
  methods: {
    inputComponents() {
      //;
      var r = this.inputs;
      for (const key in r) {
        if (r.hasOwnProperty(key)) {
          var element = r[key];
          if (element.processData) {
            const srsDef = this.inputs[element.processData.from],
              srcOptions = srsDef.options.options;
            var q = {};
            // if(!this.content[srsDef.itemValue])
            _log_(
              "reprocess...",
              element.processData.trackValueFrom,
              srsDef[element.processData.trackValueFrom],
              srsDef
            );
            q[_.get(srsDef, element.processData.trackValueFrom)] = this.content[
              element.processData.from
            ];
            var selectedOption = _.find(srcOptions, q);
            if (!selectedOption) selectedOption = [];
            const processed_data = selectedOption[element.processData.selector];
            element[element.processData.putIn][
              element.processData.putAs
            ] = processed_data;
          }
        }
      }
      return r;
    }
  },

  watch: {
    // value(val, oldVal) {
    //   if (val == oldVal) return;
    //   if (_.isString(val)) this.content = JSON.parse(val);
    //   else this.content = val;
    // },
    content: {
      handler(val, oldVal) {
        if (this.stringify) this.$emit("input", JSON.stringify(this.content));
        else this.$emit("input", this.content);
      },
      deep: true
    }
  },
  created() {
    if (_.isString(this.value)) this.content = JSON.parse(this.value);
    else this.content = this.value ? this.value : {};

    var pls = this.inputComponents();

    var newObject = {};
     for (const key in this.content) {
      if (this.content.hasOwnProperty(key)) {
        newObject[key] = this.content[key];
      }
    }
    for (const key in pls) {
      if (this.content.hasOwnProperty(key)) {
        newObject[key] = this.content[key];
      } else newObject[key] = null;
    }
    this.content = newObject;

    _log_("go for..", this.content, pls);
    //  this.$emit("input", JSON.stringify(this.content));
  }
  // methods: {}
};
</script>

<style>
.mini-row {
  padding-bottom: 4px;
}
</style>
